import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Homepage from './pages/Homepage';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import { EventsList, EventDetail, EventCategories, MyEvents } from './pages/events';
import { EmployeeDirectory, EmployeeProfile, DepartmentDirectory, TeamDirectory } from './pages/directory';
import { ForumsList, ForumDetail, ThreadDetail, PopularDiscussions } from './pages/forums';
import { AttendanceDashboard, MonthlyView, AttendanceHistory, LeaveBalance, TeamAttendance } from './pages/attendance';
import { PayrollDashboard, PayslipDetail, BenefitsOverview, TaxDocuments, PayrollHistory } from './pages/payroll';
import { TrainingDashboard, CourseCatalog, CourseDetail, MyTraining, CertificateViewer, SkillAssessment } from './pages/training';
import { SupportDashboard, TicketList, TicketDetail, KnowledgeBase, ContactSupport, LiveChat } from './pages/support';
import { CalendarDashboard, EventScheduler, MeetingRooms, PersonalCalendar, TeamCalendar, CalendarIntegration } from './pages/calendar';
import { DocumentLibrary, DocumentDetail, DocumentCategories, MyDocuments, DocumentUpload, SharedDocuments } from './pages/documents';
import { FormsLibrary, FormDetail, FormBuilder, FormSubmissions, MyForms, ApprovalWorkflow } from './pages/forms';
import { NotificationsCenter, NotificationHistory, NotificationSettings } from './pages/notifications';
import { UserProfile, AccountSettings, NotificationPrefs, PrivacySettings, ThemeCustomizer, DataExport } from './pages/profile';
import { TasksDashboard, MyTasks, TaskDetail, ProjectView, TaskCalendar, TaskAnalytics } from './pages/tasks';
import './index.css';

function App() {
  return (
    <Router>
      <div className="App min-h-screen bg-apollo-gray">
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          
          {/* Events Routes */}
          <Route path="/events" element={<EventsList />} />
          <Route path="/events/:id" element={<EventDetail />} />
          <Route path="/events/categories" element={<EventCategories />} />
          <Route path="/events/my-events" element={<MyEvents />} />

          {/* Directory Routes */}
          <Route path="/directory" element={<EmployeeDirectory />} />
          <Route path="/directory/employee/:id" element={<EmployeeProfile />} />
          <Route path="/directory/departments" element={<DepartmentDirectory />} />
          <Route path="/directory/teams" element={<TeamDirectory />} />

          {/* Forums Routes */}
          <Route path="/forums" element={<ForumsList />} />
          <Route path="/forums/:forumId" element={<ForumDetail />} />
          <Route path="/forums/thread/:threadId" element={<ThreadDetail />} />
          <Route path="/forums/popular" element={<PopularDiscussions />} />

          {/* Attendance Routes */}
          <Route path="/attendance" element={<AttendanceDashboard />} />
          <Route path="/attendance/monthly" element={<MonthlyView />} />
          <Route path="/attendance/history" element={<AttendanceHistory />} />
          <Route path="/attendance/leave-balance" element={<LeaveBalance />} />
          <Route path="/attendance/team" element={<TeamAttendance />} />

          {/* Payroll Routes */}
          <Route path="/payroll" element={<PayrollDashboard />} />
          <Route path="/payroll/payslip" element={<PayslipDetail />} />
          <Route path="/payroll/payslip/:month" element={<PayslipDetail />} />
          <Route path="/payroll/benefits" element={<BenefitsOverview />} />
          <Route path="/payroll/tax-documents" element={<TaxDocuments />} />
          <Route path="/payroll/history" element={<PayrollHistory />} />

          {/* Training Routes */}
          <Route path="/training" element={<TrainingDashboard />} />
          <Route path="/training/catalog" element={<CourseCatalog />} />
          <Route path="/training/course/:courseId" element={<CourseDetail />} />
          <Route path="/training/my-training" element={<MyTraining />} />
          <Route path="/training/certificates" element={<MyTraining />} />
          <Route path="/training/certificates/:certificateId" element={<CertificateViewer />} />
          <Route path="/training/assessments" element={<SkillAssessment />} />

          {/* Support Routes */}
          <Route path="/support" element={<SupportDashboard />} />
          <Route path="/support/tickets" element={<TicketList />} />
          <Route path="/support/tickets/:ticketId" element={<TicketDetail />} />
          <Route path="/support/knowledge-base" element={<KnowledgeBase />} />
          <Route path="/support/knowledge-base/:articleId" element={<KnowledgeBase />} />
          <Route path="/support/contact" element={<ContactSupport />} />
          <Route path="/support/chat" element={<LiveChat />} />

          {/* Calendar Routes */}
          <Route path="/calendar" element={<CalendarDashboard />} />
          <Route path="/calendar/scheduler" element={<EventScheduler />} />
          <Route path="/calendar/rooms" element={<MeetingRooms />} />
          <Route path="/calendar/personal" element={<PersonalCalendar />} />
          <Route path="/calendar/team" element={<TeamCalendar />} />
          <Route path="/calendar/integration" element={<CalendarIntegration />} />

          {/* Documents Routes */}
          <Route path="/documents" element={<DocumentLibrary />} />
          <Route path="/documents/:documentId" element={<DocumentDetail />} />
          <Route path="/documents/categories" element={<DocumentCategories />} />
          <Route path="/documents/my-documents" element={<MyDocuments />} />
          <Route path="/documents/upload" element={<DocumentUpload />} />
          <Route path="/documents/shared" element={<SharedDocuments />} />

          {/* Forms Routes */}
          <Route path="/forms" element={<FormsLibrary />} />
          <Route path="/forms/:formId" element={<FormDetail />} />
          <Route path="/forms/builder" element={<FormBuilder />} />
          <Route path="/forms/submissions" element={<FormSubmissions />} />
          <Route path="/forms/my-forms" element={<MyForms />} />
          <Route path="/forms/workflow" element={<ApprovalWorkflow />} />

          {/* Notifications Routes */}
          <Route path="/notifications" element={<NotificationsCenter />} />
          <Route path="/notifications/history" element={<NotificationHistory />} />
          <Route path="/notifications/settings" element={<NotificationSettings />} />

          {/* Profile Routes */}
          <Route path="/profile" element={<UserProfile />} />
          <Route path="/profile/settings" element={<AccountSettings />} />
          <Route path="/profile/notifications" element={<NotificationPrefs />} />
          <Route path="/profile/privacy" element={<PrivacySettings />} />
          <Route path="/profile/theme" element={<ThemeCustomizer />} />
          <Route path="/profile/export" element={<DataExport />} />

          {/* Tasks Routes */}
          <Route path="/tasks" element={<TasksDashboard />} />
          <Route path="/tasks/my-tasks" element={<MyTasks />} />
          <Route path="/tasks/:taskId" element={<TaskDetail />} />
          <Route path="/tasks/projects" element={<ProjectView />} />
          <Route path="/tasks/calendar" element={<TaskCalendar />} />
          <Route path="/tasks/analytics" element={<TaskAnalytics />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
